import { useEffect, useState } from 'react';
import { useFrontendSettings } from '@frontend/utils/hooks/useFrontendSettings';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { getJson } from '../../../store/fetch';
import { Button, Icon } from '../common';

interface ISsoData {
    afd3Code: string;
    dateString: string;
    hashCode: string;
    instCode: string;
    mCode: string;
    pBsn: string;
    pCode: string;
    pGebdat: string;
    pGeboortenaam: string;
    pVoorletters: string;
}

export function SsoEmbloomGradingButton(props: { request: IRequestGetOne }) {
    const [ssoData, setSsoData] = useState<ISsoData>();
    const { frontendSettings } = useFrontendSettings();

    useEffect(() => {
        if (props.request.authorization && props.request.authorization.canAddExaminationDiagnosticReport) {
            loadSsoData();
        }
    }, [props.request]);

    if (!ssoData) {
        return null;
    }

    return (
        <form action={frontendSettings.embloomSsoEndpoint}>
            <Button
                color="secondary"
                large
                submit
            >
                <Icon icon="external" />
                Beoordeel onderzoek
            </Button>
            <InputField
                name="InstCode"
                value={ssoData.instCode}
            />
            <InputField
                name="Afd3Code"
                value={ssoData.afd3Code}
            />
            <InputField
                name="MCode"
                value={ssoData.mCode}
            />
            <InputField
                name="dateString"
                value={ssoData.dateString}
            />
            <InputField
                name="hashCode"
                value={ssoData.hashCode}
            />
            <InputField
                name="PCode"
                value={ssoData.pCode}
            />
            <InputField
                name="PVoorletters"
                value={ssoData.pVoorletters}
            />
            <InputField
                name="PGeboortenaam"
                value={ssoData.pGebdat}
            />
            <InputField
                name="PGebdat"
                value={ssoData.pGeboortenaam}
            />
            <InputField
                name="PBSN"
                value={ssoData.pBsn}
            />
        </form>
    );

    async function loadSsoData() {
        const result = await getJson(`/api/procedures/${props.request.id}/embloom/ssoGradingData`);
        setSsoData(result.json.ssoData);
    }
}

function InputField(props: { name: string; value: string }) {
    return (
        <input
            name={props.name}
            type="hidden"
            value={props.value}
        />
    );
}
